import api from '../index';

export const operationsService = {
  previewImport: (file: File) => { const data = new FormData(); data.append('file', file); return api.post('/operations/imports/preview', data, { headers: { 'Content-Type': 'multipart/form-data' } }); },
  commitImport: (id: number) => api.post(`/operations/imports/${id}/commit`),
  getImports: () => api.get('/operations/imports'),
  getLocations: () => api.get('/operations/locations'),
  getDashboard: () => api.get('/operations/dashboard'),
  getSettings: () => api.get('/operations/settings'),
  saveBilling: (data: any) => api.put('/operations/settings/billing', data),
  createMeterType: (data: any) => api.post('/operations/meter-types', data),
  updateMeterType: (id: number, data: any) => api.put(`/operations/meter-types/${id}`, data),
};

export const invoiceService = {
  list: (params?: any) => api.get('/bills', { params }),
  preview: (data: any) => api.post('/bills/preview', data),
  generate: (data: any) => api.post('/bills/generate', data),
  sendBatch: (bill_ids: number[]) => api.post('/bills/send-batch', { bill_ids }),
  send: (id: number) => api.post(`/bills/${id}/send`),
  markPaid: (id: number, is_paid: boolean) => api.put(`/bills/${id}/payment-status`, { is_paid }),
  pdf: (id: number) => api.get(`/bills/${id}/pdf`, { responseType: 'blob' }),
  link: (id: number) => api.get(`/bills/${id}/link`),
};
